// a configurable base url so that it can fit into any deployment system;
// namely development, test/uat and production

import { msalConfig } from "./msal/authConfig";
let baseUrl = msalConfig.apiUrl;

// url mapper for all the apis
const urls = {
  lookup: `${baseUrl}/lookup`,
  cityAndPostalCode: `${baseUrl}/country`, // /{countryid}/addressinfo
  checkDuplicate: `${baseUrl}/businesspartner/duplicate`,
  city: `${baseUrl}/city`,
  postalCode: `${baseUrl}/postalcode`,
  businessPartner: `${baseUrl}/businesspartner`,
  fetchBankNumber: `${baseUrl}/GetBankNumber`,
  searchBP: `${baseUrl}/search`,
  notification: `${baseUrl}/notification`,
  changeLog: `${baseUrl}/getauditlog`,
  fetchStewardBusinessPartnerLists: `${baseUrl}/businesspartner/search`,
  users: `${baseUrl}/userlist`,
  bankBranch: `${baseUrl}/bank/bankcode`,
  countryBanks: `${baseUrl}/country`,
};
export default urls;
